import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import './Login.css';

const Login = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const navigate = useNavigate();

  // Predefined admin credentials
  const ADMIN_CREDENTIALS = {
    username: 'tushitasingh',
    password: 'bdc12345',
  };

  // // Check if user is already logged in and redirect
  // useEffect(() => {
  //   const token = sessionStorage.getItem('token');
  //   const user = token ? JSON.parse(token) : null;
  //   console.log(user.username); // Example: Output the username

  //   if (user) {
  //     navigate('/admin/create-blog'); // Redirect if token exists
  //   }
  // }, [navigate]);


  // Handle login
  const handleLogin = (e) => {
    e.preventDefault();

    // Check if entered credentials match the predefined credentials
    if (
      username === ADMIN_CREDENTIALS.username &&
      password === ADMIN_CREDENTIALS.password
    ) {
      // Store username and password in the token
      const token = JSON.stringify({
        username: username,
        password: password,
      });
      sessionStorage.setItem('token', token); // Save token in sessionStorage

      alert('Login successful!');
      navigate('/admin'); // Redirect to the blog creation page
    } else {
      alert('Invalid username or password. Please try again.');
    }
  };

  return (
    <div className="login-page">
      <form onSubmit={handleLogin} className="login-form">
        <input
          type="text"
          name="username"
          placeholder="Username"
          value={username}
          onChange={(e) => setUsername(e.target.value)}
          required
        />
        <input
          type="password"
          name="password"
          placeholder="Password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          required
        />
        <button type="submit" className="login-button">Login</button>
      </form>
    </div>
  );
};

export default Login;
